import React from 'react';
import { Routes, Route, Link, useLocation, Navigate } from 'react-router-dom';
import styles from './ManageArea.module.css';
import UserManagement from './UserManagement';

const ManageArea = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const isUsersActive = pathname.endsWith('/manage/users') || pathname.endsWith('/manage') || pathname.endsWith('/manage/');
  const isFinanceActive = pathname.endsWith('/manage/finance');

  return (
    <div className={styles.manageArea}>
      <h1>Manage</h1>
      
      <div className={styles.tabs}>
        <Link 
          to="/admin/manage/users" 
          className={`${styles.tab} ${isUsersActive ? styles.active : ''}`}
        >
          Users
        </Link>
        <Link 
          to="/admin/manage/finance" 
          className={`${styles.tab} ${isFinanceActive ? styles.active : ''}`}
        >
          Finance
        </Link>
      </div>

      <div className={styles.tabContent}>
        <Routes>
          <Route path="users" element={<UserManagement />} />
          <Route path="finance" element={<div className={styles.placeholder}>Finance management coming soon...</div>} />
          <Route path="" element={<Navigate to="users" replace />} />
        </Routes>
      </div>
    </div>
  );
};

export default ManageArea;

